'use client';

import { Pagination, Stack } from "@mui/material";
import { useEventList } from "@/app/features/sites/events/EventListContext";

export default function EventListPagination() {
    const {
        pagination,
        setPage,
    } = useEventList();

    if (pagination.pageCount <= 1) return;

    return (
        <Stack
            direction="row"
            spacing={4}
            justifyContent="center"
            sx={{
                width: '100%',
                padding: (theme) => theme.spacing(4, '10%'),
            }}
        >
            {pagination.pageCount > 1 && (
                <Pagination
                    count={pagination.pageCount}
                    page={pagination.page}
                    onChange={(_, value) => {
                        setPage(value)
                    }}
                    showFirstButton
                    showLastButton
                    color="primary"
                />
            )}
        </Stack>
    );
}